/**
 * Criação manual de membro órfão (uso raro — os registros normalmente
 * nascem da importação do sistema antigo). A versão anterior gravava um
 * único campo "name", que não existe no modelo — criar sempre falhava.
 */
import {
  CreateContextProvider,
  SimpleForm,
  TextInput,
  useCreateController,
} from "react-admin";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";

export const OrphanedUsersCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "orphaned-users/crud",
  });
  return (
    <CreateContextProvider value={controller}>
      <SimpleForm>
        <PageTopBreadcrumb
          title="Membros Órfãos"
          firstPath="/#/orphaned-users/crud"
          secondTitle="Novo"
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Novo Membro Órfão" />
          <CardContent>
            <Grid container columnSpacing={2} rowSpacing={0.5}>
              <Grid item xs={12}>
                <TextInput
                  source="sNome"
                  label="Nome"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="nCPF"
                  label="CPF"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextInput
                  source="nMatricula"
                  label="Matrícula"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextInput
                  source="nDigito"
                  label="Dígito"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="sEmailPart"
                  label="E-mail"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="sCelular"
                  label="Celular"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="sTelResid"
                  label="Telefone residencial"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="oldId"
                  label="ID legado"
                  fullWidth
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextInput
                  source="issueReason"
                  label="Razão do erro"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </CreateContextProvider>
  );
};
